module.exports = __webpack_public_path__ + "img/logo1.a5d6fa57.png";